/**
 * Files on the clipboard, named so they can be told apart.
 *
 * A pasted screenshot arrives as a File called "image.png" — every one of them, so three
 * pastes in a row would list three identically named attachments. They are renamed with the
 * time they were pasted. Anything that is not a file (copied text) yields nothing, which is
 * how the caller knows to leave the paste alone.
 */
const GENERIC_NAMES = new Set(['image.png', 'image.jpg', 'image.jpeg', 'image.gif', 'image.webp', 'blob', ''])

const pad = (n: number) => String(n).padStart(2, '0')

export function filesFromClipboard(data: DataTransfer | null, now: Date = new Date()): File[] {
  if (!data) return []
  const out: File[] = []
  for (const file of Array.from(data.files ?? [])) {
    if (GENERIC_NAMES.has(file.name.toLowerCase()) && file.type.startsWith('image/')) {
      const ext = file.type.split('/')[1]?.replace('jpeg', 'jpg') || 'png'
      const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}.${pad(now.getMinutes())}.${pad(now.getSeconds())}`
      out.push(new File([file], `Pasted image ${stamp}${out.length ? ` (${out.length + 1})` : ''}.${ext}`, { type: file.type }))
    } else {
      out.push(file)
    }
  }
  return out
}
